import React, {Component} from "react";
import {Button, Form} from "reactstrap";
import './DepoIade.css';
import {request} from "../../../../../helper/APIUtils";
import {showAxiosError} from "../../../../../helper/helper";

class DepoIade extends Component {
    constructor(props) {
        super(props);
        this.state = {
            depo: null,
            file: null
        };
    }

    onDrop = (file) => {
        if (!file && file === null)
            return;
        let formData = new FormData();
        formData.append("file", file);
        request({
            url: `/depo/iade/${this.state.depo}`,
            method: "post",
            data: formData
        }).then((response) => {
            this.props.listener(response.data);
        }).catch(function (error) {
            showAxiosError(error);
        });
    };

    gekOnClick = () => {
        this.setState({file: null, depo: "GEK"});
        document.getElementById('upload-file').value = null;
        document.getElementById('upload-file').click();
    };

    hedefAllianceOnClick = () => {
        this.setState({file: null, depo: "HEDEF_ALLIANCE"});
        document.getElementById('upload-file').value = null;
        document.getElementById('upload-file').click();
    };

    renderDropdown = () => {
        let depolar = [
            {value: "GEK", label: "GEK - BEK - İskoop", onClick: this.gekOnClick},
            {value: "HEDEF_ALLIANCE", label: "HEDEF ALLIANCE", onClick: () => this.props.history.push("/invoice/iade/hedef")},
            {value: "SELCUK", label: "Selçuk Ecza Deposu", onClick: () => this.props.history.push("/invoice/iade/selcuk")},
            {value: "AS", label: "As Ecza Deposu", onClick: () => this.props.history.push("/invoice/iade/as-ecza")},
            {value: "NEVZAT", label: "Nevzat Ecza Deposu", onClick: () => this.props.history.push("/invoice/iade/nevzat")},
            {value: "Imaj", label: "İmaj Ecza Deposu", onClick: () => this.props.history.push("/invoice/iade/imaj")},
            {value: "AFYON", label: "Afyon Ecza Deposu", onClick: () => this.props.history.push("/invoice/iade/afyon")},
            {value: "DENGE", label: "Denge Ecza Deposu", onClick: () => this.props.history.push("/invoice/iade/Denge")},
            {value: "SANCAK", label: "Sancak Ecza Deposu", onClick: () => this.props.history.push("/invoice/iade/sancak")},
            {value: "MADEN", label: "Maden Ecza Deposu", onClick: () => this.props.history.push("/invoice/iade/maden-ecza")},
            {value: "KIZILAY", label: "Kızılay Ecza Deposu", onClick: () => this.props.history.push("/invoice/iade/kizilay-ecza")}
        ];

        return (
          depolar.map(depo => {
              return (<a key={depo.value} className="dropdown-item" onClick={depo.onClick}>{depo.label}</a>);
          })
        );
    };

    render() {
        return (
          <div style={{float: 'left'}}>
              <Form>
                  <Button className="MenuBtn2 listt" style={{marginTop: window.innerWidth < 1280 ? '0px' : '10px'}}
                          type="button"
                          id="iadeDropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false">
                      Depo iade
                  </Button>
                  <div className="dropdown-menu" aria-labelledby="iadeDropdownMenuButton">
                      {
                          this.renderDropdown()
                      }
                  </div>
                  <input type="file" accept=".xml" style={{display: 'none'}}
                         id={"upload-file"}
                         onChange={event => {
                             this.onDrop(event.target.files[0]);
                         }}
                  />
              </Form>
          </div>
        );
    }
}

export default DepoIade;